import { Link } from "react-router-dom";
import { trackQuoteRequest } from "@/utils/gtag";

export default function Hero() {
  return (
    <section className="relative w-full h-[100vh] min-h-[720px] overflow-hidden">
      <style>{`
        @keyframes kenburns {
          0%   { transform: scale(1.05) translate(2%, 1%); }
          33%  { transform: scale(1.12) translate(-1%, 0.5%); }
          66%  { transform: scale(1.08) translate(1.5%, -0.8%); }
          100% { transform: scale(1.05) translate(2%, 1%); }
        }
        .hero-kenburns {
          animation: kenburns 24s ease-in-out infinite;
          transform-origin: center center;
          will-change: transform;
        }
      `}</style>
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <img
          src="https://static.readdy.ai/image/6d19e52ea24a99432a176a0adb81cdc8/8a74593ddc315d06a6992e436c8d74be.png"
          alt="부산 광안대교 전경"
          className="hero-kenburns w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-navy-950/65 via-navy-900/45 to-navy-950/70"></div>

      <div className="relative z-10 h-full w-full px-5 md:px-12 lg:px-16 flex flex-col justify-center">
        <div className="max-w-4xl w-full">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-white/10 backdrop-blur border border-white/20 text-white/90 text-xs mb-6 md:mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-point-400"></span>
            SINCE 2010 · 전문건설업 등록 · 장애인기업
          </div>

          <h1 className="font-hero text-white text-4xl sm:text-5xl md:text-7xl lg:text-8xl leading-[1.1] md:leading-[1.05] mb-5 md:mb-8">
            신뢰를 시공하는
            <br />
            <span className="text-point-400">전문건설업체</span>
          </h1>

          <p className="text-white/85 text-sm md:text-xl font-light mb-8 md:mb-12 tracking-wide leading-relaxed">
            도장, 습식방수, 석공사, 실내건축 전문건설업<br className="sm:hidden" />
            <span className="hidden sm:inline"> &nbsp;·&nbsp; </span>
            <span className="sm:hidden">· </span>에폭시, 우레탄, 페인트 제조, 도매, 소매
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full sm:w-auto">
            <Link
              to="/portfolio"
              className="group inline-flex items-center justify-center gap-3 px-7 py-4 bg-point-500 hover:bg-point-600 text-white text-sm md:text-base font-semibold rounded-full transition-all duration-500 ease-out hover:-translate-y-0.5 cursor-pointer whitespace-nowrap w-full sm:w-auto"
            >
              시공사례 보기
              <div className="w-5 h-5 flex items-center justify-center transition-transform group-hover:translate-x-1">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
            <Link
              to="/contact"
              onClick={() => trackQuoteRequest()}
              className="group inline-flex items-center justify-center gap-3 px-7 py-4 bg-white/10 hover:bg-white/20 backdrop-blur border border-white/30 text-white text-sm md:text-base font-semibold rounded-full transition-all duration-500 ease-out hover:-translate-y-0.5 cursor-pointer whitespace-nowrap w-full sm:w-auto"
            >
              무료 견적문의
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-file-list-3-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/70">
        <span className="text-xs tracking-[0.3em] uppercase">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/60 to-transparent animate-pulse"></div>
      </div>

      <div className="hidden lg:grid absolute bottom-0 left-0 right-0 z-10 grid-cols-4 border-t border-white/15 bg-white/5 backdrop-blur-sm">
        {[
          { k: "16+", v: "Years Experience" },
          { k: "400+", v: "Projects Completed" },
          { k: "120+", v: "Public Sector" },
          { k: "98%", v: "Client Satisfaction" },
        ].map((s, i) => (
          <div
            key={s.k}
            className={`px-8 py-6 flex items-center gap-4 ${
              i !== 3 ? "border-r border-white/15" : ""
            }`}
          >
            <div className="font-hero text-3xl text-white">{s.k}</div>
            <div className="text-xs uppercase tracking-widest text-white/70">
              {s.v}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}